var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRelumeicon = function SvgRelumeicon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#relume_icon_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "m14.984 4.096-.112-.2a1.657 1.657 0 0 0-.592-.584L8.912.216a1.6 1.6 0 0 0-.8-.216H7.88a1.6 1.6 0 0 0-.8.216L1.712 3.32a1.6 1.6 0 0 0-.584.584l-.112.2a1.6 1.6 0 0 0-.216.8v6.2c0 .281.075.557.216.8l.112.2c.144.24.344.44.584.584l5.376 3.096c.242.144.519.219.8.216h.224a1.6 1.6 0 0 0 .8-.216l5.368-3.104a1.52 1.52 0 0 0 .584-.584l.12-.2c.14-.244.214-.52.216-.8v-6.2a1.6 1.6 0 0 0-.216-.8ZM7.88 1.6h.232L12.8 4.304 8 7.072 3.2 4.304 7.88 1.6ZM8.8 14l4.68-2.704.12-.2V5.688L8.8 8.464V14Z",
    clipRule: "evenodd"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "relume_icon_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h16v16H0z"
  })))));
};
export default SvgRelumeicon;